import { globalHistory, Router } from '@reach/router';
import React, { lazy, useEffect } from 'react';
import { connect } from 'react-redux';
import PrivateRoute from '../components/private-route';
import PublicRoute from '../components/public-route';

const NotFoundPage = lazy(() => import('../layouts/404'));
const DashboardPage = lazy(() => import('../layouts/dashboard'));

const LoginPage = lazy(() => import('../layouts/login'));
const UserProfilePage = lazy(() => import('../layouts/user-profile'));
const MerchantProfilePage = lazy(() => import('../layouts/merchant-profile'));
const StoresPage = lazy(() => import('../layouts/stores'));
const UsersPage = lazy(() => import('../layouts/users'));
const CustomersPage = lazy(() => import('../layouts/customers'));
const StoreLocatorPage = lazy(() => import('../layouts/store-locator'));
const inventoryPage = lazy(() => import('../layouts/inventory-manager'));
const ReportsPage = lazy(() => import('../layouts/reports'));
const ForgotPasswordPage = lazy(() =>
  import('../components/auth/forget-password'),
);
const AwsMap = lazy(() => import('../layouts/aws-map'));
export const ROUTE_NAMES = {
  AUTH: '/login',
  HOME: '/',
  ORDERSHIPMENTDETAILS: '/order-shipment-details/:orderShipmentId',
  STORES: '/stores',
  USERS: '/users',
  CUSTOMERS:'/customers',
  PROFILE: '/profile',
  FORGOTPASSWORD: '/forgot',
  AWS_MAP: '/aws-map',
  STORE_LOCATOR: '/store-locator',
  INVENTORY_MANAGER: '/inventory-manager',
  REPORTS: '/reports',
};

const PAGE_TITLES = {
  '/': 'HOME',
  '/order-shipment-details/*': 'ORDER DETAILS',
  '/store-locator': 'STORE LOCATOR',
  '/reports': 'REPORTS',
  '/stores': 'STORES MANAGEMENT',
  '/users': 'USER MANAGEMENT',
  '/inventory-manager':'INVENTORY MANAGER',
  '/profile': 'MY PROFILE',
  '/merchantprofile/': 'MERCHANT PROFILE',
  '/userprofile/': 'USER PROFILE',
};

const RouteswithoutRedux = (props) => {
  const { setCurrentPath, accessModules } = props;

  const userManagementModule = accessModules?.find(
    (a) => a.module === 'user-management',
  );
  const customerLocatorModule = accessModules?.find(
    (a) => a.module === 'customer-management',
  );
  const storeManagementModule = accessModules?.find(
    (a) => a.module === 'store-management',
  );
  const storeLocatorModule = accessModules?.find(
    (a) => a.module === 'store-locator',
  );
  const inventoryModule = accessModules?.find(
    (a) => a.module === 'inventory-manager',
  );
  const reportsModule = accessModules?.find((a) => a.module === 'reports');
  const customActions = accessModules?.find(
    (a) => a.module === 'custom-actions',
  );

  useEffect(() => {
    globalHistory.listen(({ location }) => {
      const title = PAGE_TITLES[location.pathname];
      if (title) {
        setCurrentPath({
          currentPageTitle: title,
        });
      }
    });
    if (globalHistory?.location?.pathname) {
      const title = PAGE_TITLES[globalHistory.location.pathname];
      if (title) {
        setCurrentPath({
          currentPageTitle: title,
        });
      }
    }
  }, [setCurrentPath]);

  return (
    <>
      <Router>
        <PublicRoute path={ROUTE_NAMES.AUTH} component={LoginPage} />
        <PublicRoute
          path={ROUTE_NAMES.FORGOTPASSWORD}
          component={ForgotPasswordPage}
        />
        <PrivateRoute path={ROUTE_NAMES.HOME} component={DashboardPage} />
        <PrivateRoute path={ROUTE_NAMES.AWS_MAP} component={AwsMap} />
        {storeManagementModule?.actions.indexOf('full') > -1 && (
          <>
            <PrivateRoute path={ROUTE_NAMES.STORES} component={StoresPage} />
            <PrivateRoute path="/stores/:editType" component={StoresPage} />
          </>
        )}
        {userManagementModule?.actions.indexOf('full') > -1 && (
          <PrivateRoute path={ROUTE_NAMES.USERS} component={UsersPage} />
        )}
          {customerLocatorModule?.actions.indexOf('full') > -1 && (
          <PrivateRoute path={ROUTE_NAMES.CUSTOMERS} component={CustomersPage} />
        )}
        {storeLocatorModule?.actions.indexOf('full') > -1 && (
          <PrivateRoute
            path={ROUTE_NAMES.STORE_LOCATOR}
            component={StoreLocatorPage}
          />
        )}
         
          <PrivateRoute
            path={ROUTE_NAMES.INVENTORY_MANAGER}
            component={inventoryPage}
          />
        

        {(customActions?.actions['view-user-profile'] ||
          customActions?.actions['edit-user-profile']) && (
          <>
            <PrivateRoute path="/userprofile/*" component={UserProfilePage} />
          </>
        )}
        {(customActions?.actions['view-merchant-profile'] ||
          customActions?.actions['edit-merchant-profile']) && (
          <>
            <PrivateRoute
              path="/merchantprofile/*"
              component={MerchantProfilePage}
            />
          </>
        )}

        {/* {reportsModule?.actions.indexOf('full') > -1 && (
          <PrivateRoute
            path={ROUTE_NAMES.REPORTS}
            component={ReportsPage}
          />
        )} */}
        <PrivateRoute path={ROUTE_NAMES.REPORTS} component={ReportsPage} />
        <PrivateRoute path="/reports" component={StoresPage} />

        <PrivateRoute default component={NotFoundPage} />
      </Router>
    </>
  );
};

const stateMapper = (state) => ({
  accessModules: state.auth.accessModules,
});
const dispatchMapper = (dispatch) => ({
  setCurrentPath: dispatch.page.setCurrentPath,
});

export const Routes = connect(stateMapper, dispatchMapper)(RouteswithoutRedux);
